import { theme } from '../../../theme';

export const switchStyle = {
  switchUi: {
    '& .MuiSwitch-root': {
      p: 0.75,
      '& .MuiSwitch-track': {
        background: theme.palette.myPrimary.lightBlue70,
        borderRadius: 4,
      },
      '& .MuiButtonBase-root.Mui-checked': {
        color: theme.palette.myPrimary.white,
        '& +.MuiSwitch-track': {
          background: theme.palette.myPrimary.lightBlue100,
          opacity: 0.8,
        },
      },
    },
  },
};
